import { render, staticRenderFns } from "./ShowResult.vue?vue&type=template&id=5f105a28&scoped=true&"
import script from "./ShowResult.vue?vue&type=script&lang=ts&"
export * from "./ShowResult.vue?vue&type=script&lang=ts&"
import style0 from "./ShowResult.vue?vue&type=style&index=0&id=5f105a28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f105a28",
  null
  
)

export default component.exports